import {mixedMeasure} from './index';

function measureName  (m, suffix) {
  m = m || this.measures()[0];
  let name = m.field;
  if (!this.aggregated() || m.field !== mixedMeasure.field) name += '-' + m.op;
  return name + (suffix !== undefined ?  ('-' + suffix) : '');
}

export default measureName;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/measureName.js